var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5833 56.2496C64.5833 64.5829 54.1667 70.8329 54.1667 77.0829H45.8333C45.8333 70.8329 35.4167 64.5829 35.4167 56.2496C35.4167 48.2079 41.9583 41.6662 50 41.6662C58.0417 41.6662 64.5833 48.2079 64.5833 56.2496ZM54.1667 81.2496H45.8333V83.3329C45.8333 85.6246 47.7083 87.4996 50 87.4996C52.2917 87.4996 54.1667 85.6246 54.1667 83.3329V81.2496ZM79.1667 54.1662C79.1667 59.9579 77.4583 65.3746 74.5 69.9162C73.4583 71.5412 73.7083 73.7079 75.0833 75.0829C76.9167 76.9162 80.0833 76.6662 81.5 74.4579C85.2917 68.6246 87.5 61.6662 87.5 54.1662C87.5 44.3329 83.7083 35.3746 77.5 28.6662C75.875 26.9162 73.125 26.8746 71.4583 28.5412C69.875 30.1246 69.875 32.6662 71.375 34.3329C76.2083 39.5412 79.1667 46.4996 79.1667 54.1662ZM65.2083 19.3746L53.5833 7.74956C52.25 6.41622 50 7.33289 50 9.20789V16.6662C29.2917 16.6662 12.5 33.4579 12.5 54.1662C12.5 61.6662 14.7083 68.6246 18.5 74.4996C19.9167 76.7079 23.0833 76.9579 24.9167 75.1246C26.2917 73.7496 26.5417 71.6246 25.5 69.9996C19.7083 61.0412 18.6667 48.7496 26.0417 36.6662C31.0417 28.5412 40.4583 24.2079 50 24.9996V32.4579C50 34.3329 52.25 35.2496 53.5417 33.9162L65.1667 22.2912C66 21.4996 66 20.1662 65.2083 19.3746Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTraining);
export default __webpack_public_path__ + "static/media/model_training.dbc1499534ec1733c2ad0e99701eb8f7.svg";
export { ForwardRef as ReactComponent };